import { createSlice } from "@reduxjs/toolkit";
import { getFoodListAction } from "./orderFood.action";
import { logout } from "../authenticate/authenticate.action";

const initialState = {
	foodList: [],
	categoryList: [],
	isLoading: false,
};

const orderFoodSlicer = createSlice({
	name: "orderFood",
	initialState: initialState,
	reducers: {},
	extraReducers: {
		[getFoodListAction.pending]: (state) => {
			state.isLoading = true;
		},
		[getFoodListAction.fulfilled]: (state, action) => {
			const { foodList, categoryList } = action.payload;
			state.foodList = foodList;
			state.categoryList = categoryList;

			state.isLoading = false;
		},
		[getFoodListAction.rejected]: (state) => {
			state.isLoading = false;
		},
		[logout.fulfilled]: (state) => {
			state.foodList = [];
			state.categoryList = [];
		},
	},
});

export const {} = orderFoodSlicer.actions;
export default orderFoodSlicer.reducer;
